import { render, staticRenderFns } from "./refound-reject-detail.vue?vue&type=template&id=23558c69&scoped=true&"
import script from "./refound-reject-detail.vue?vue&type=script&lang=js&"
export * from "./refound-reject-detail.vue?vue&type=script&lang=js&"
import style0 from "./refound-reject-detail.vue?vue&type=style&index=0&id=23558c69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23558c69",
  null
  
)

export default component.exports